import React from 'react'
import Routes from '@brainstud/react-tbl/themes/pgw/v1/routes'
import { Redirect } from 'react-router-dom'
import { scrollTop } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { Page } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import { withLesson } from '@brainstud/react-tbl/themes/pgw/v1/containers'
import { ContentType } from '@brainstud/react-tbl/features/chapters/views/lesson/types'
// import LessonArticle from './lesson/LessonArticle'
// import LessonQuiz from './lesson/LessonQuiz'
import LessonExercise from './templates/LessonExercise'
import LessonPage from './templates/LessonPage'

class ChapterLessonView extends React.Component {
  // TODO set theme
  componentDidMount() {
    scrollTop()

    this.setTheme()
    this.setLocation()
    this.setProgress()
  }

  componentDidUpdate(prevProps) {
    if(prevProps.match.params.chapter !== this.props.match.params.chapter) {
      scrollTop()
      this.setTheme()
    }

    if(prevProps.match.params.lesson !== this.props.match.params.lesson) {
      scrollTop()
      this.setLocation()
      this.setProgress()
    }
  }

  setTheme() {
    this.props.app.triggerTheme(this.props.chapter.navigation.theme || 'default')
  }

  setLocation() {
    this.props.app.setLocation({ label: 'lesson', id: this.props.lesson.id })
  }

  setProgress() {
    this.props.setChapterProgress({
      id: this.props.match.params.chapter,
      data: this.props.match.params.lesson,
    })
  }

  handleBack = e => {
    const lessonIndex = this.props.chapter.lessons.indexOf(this.props.lesson)
    const prevLesson = this.props.chapter.lessons[lessonIndex - 1]
    let prevRoute = Routes.to('home')

    if(prevLesson) {
      prevRoute = Routes.to('lesson', { chapter: this.props.chapter.slug, lesson: prevLesson.slug })
    } else {
      // if(this.props.chapter.intro) {
        prevRoute = Routes.to('chapter', { chapter: this.props.chapter.slug })
      // }
    }

    this.props.history.push(prevRoute)
  }

  handleNext = e => {
    const lessonIndex = this.props.chapter.lessons.indexOf(this.props.lesson)
    const nextLesson = this.props.chapter.lessons[lessonIndex + 1]
    let nextRoute = Routes.to('home')

    if(nextLesson) {
      nextRoute = Routes.to('lesson', { chapter: this.props.chapter.slug, lesson: nextLesson.slug })
    }

    if(lessonIndex === this.props.chapter.lessons.length-1) {
      if(this.props.chapter.summary) {
        if(this.props.chapter.navigation.progress.status !== 'done') {
          this.props.setNavigationProgress({
            id: this.props.chapter.navigation.id,
            data: {
              ...this.props.chapter.navigation.progress,
              progress: this.props.chapter.lessons.length + 1,
              status: 'done',
            }
          })
          this.props.app.willProgress(this.props.chapter.navigation.prefix)
        }

        this.props.app.toggleModal(null, 'summary', {
          chapter: this.props.chapter,
          progress: this.props.chapter.navigation.progress,
        })

        return
      } else {
        if(this.props.chapter.navigation.progress.status !== 'done') {
          this.props.setNavigationProgress({
            id: this.props.chapter.navigation.id,
            data: {
              ...this.props.chapter.navigation.progress,
              progress: lessonIndex + 2,
            }
          })
          this.props.app.willProgress(this.props.chapter.navigation.prefix)
        }
      }
    } else {
      if(this.props.chapter.navigation.progress.status !== 'done') {
        this.props.setNavigationProgress({
          id: this.props.chapter.navigation.id,
          data: {
            ...this.props.chapter.navigation.progress,
            progress: lessonIndex + 2,
          }
        })
        this.props.app.willProgress(this.props.chapter.navigation.prefix)
      }
    }

    this.props.history.push(nextRoute)
  }

  handleSaveData = data => {
    this.props.setChapterProgress({
      id: this.props.lesson.id,
      data,
    })
  }

  render() {
    const { chapter, lesson } = this.props

    if(!lesson) {
      return <Redirect to={Routes.to('chapter', { chapter: chapter.slug })} />
    }

    return (
      <Page name={`Lesson Page-Lesson-${this.props.chapter.prefix}-${this.props.lesson.prefix}`} theme={this.props.app.theme}>
        <CurrentLessonTemplate
          handleBack={this.handleBack}
          handleNext={this.handleNext}
          chapter={chapter}
          lesson={lesson}>

          <ContentType
            save={this.handleSaveData}
            data={lesson.data}
            type={lesson.type}
            {...this.props} />

        </CurrentLessonTemplate>
      </Page>
    )
  }
}

// const CurrentChapterLesson = props => {
//   switch(props.lesson.type) {
//     case 'quiz':
//       return <LessonQuiz {...props} />
//
//     default:
//       return <LessonArticle {...props} />
//   }
// }

const CurrentLessonTemplate = props => {
  switch(props.lesson.type) {
    case 'exercise':
      return <LessonExercise {...props} />

    default:
      return <LessonPage {...props} />
  }
}

export default withLesson(ChapterLessonView)
